<template>
  <div class="contain">
    <div class="banner"><img src="../assets/images/banner.jpg"/></div>
    <div class="clear"></div>
    <div class="main">
      <div class="left mt15">
        <!-- 招生信息 -->
        <div class="c_tit"><p>{{schNews.name}}<span>NEWS</span></p>
          <router-link class="more" :to="'/home/list/'+schNews.id">MORE</router-link>
        </div>
        <div class="picnew">
          <a href="javascript:;" class="img"><img src="../assets/images/img1.png"/></a>
          <div class="new_list">
            <news-list :title="schNews"></news-list>
          </div>
        </div>
      </div>
      <div class="right mt20">
        <ul class="quickbtn">
          <li>
            <a href="javascript:;" @click="jump('/home/encrollabout')"><span class="fl"><img
              src="../assets/images/qk_img1.jpg"/></span>报名入口</a>
          </li>
          <li>
            <a href="javascript:;" @click="jump('/home/print')"><span class="fl"><img
              src="../assets/images/qk_img2.png"/></span>准考证打印</a>
          </li>
          <li>
            <a href="javascript:;" @click="jump('/home/query')"><span class="fl"><img
              src="../assets/images/qk_img3.png"/></span>录取查询</a>
          </li>
          <li>
            <a href="javascript:;" @click="jump('/home/queryList')"><span class="fl"><img
              src="../assets/images/qk_img4.jpg"/></span>成绩查询</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="clear"></div>
     <div class="main">
      <ul class="news">
        <li>
          <!-- 招生计划 -->
          <div class="c_tit mt15"><p>{{encroll.name}}<span>ADMISSION</span></p>
            <router-link class="more" :to="'/home/list/'+encroll.id">MORE</router-link>
          </div>
          <news-list :title="encroll"></news-list>
        </li>
        <li>
          <!-- 历年招人 -->
          <div class="c_tit mt15"><p>{{subject.name}}<span>CLASS</span></p>
            <router-link class="more" :to="'/home/list/'+subject.id">MORE</router-link>
          </div>
          <news-list :title="subject"></news-list>
        </li>
      </ul>
    </div>
    <div class="main posr">
    <!-- 热门专业 -->
      <div class="c_tit mt15"><p>{{profession.name}}<span>PROFESSIONAL</span></p></div>
      <router-link :to="'/home/list/'+profession.id" class="pMore posa">MORE</router-link>
      <ul class="profession mt5">
        <li v-for="(item,index) in profession.arts"
            :key="index" v-if="profession">
          <router-link :to="'/home/article/'+profession.id+'/'+item.id">{{item.name}}</router-link>
        </li>
      </ul>
    </div>
    <div class="clear"></div>
    <div class="main">
      <ul class="manger mt15">
        <li v-for="(item,index) in imgNew.arts" :key="index">
          <router-link :to="'/home/article/'+imgNew.id+'/'+item.id">
            <span>{{item.name}}</span>
            <p v-html="item.des"></p>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
    <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
  </div>
</template>

<script>
import newsList from "../components/newsList";
import footComp from "../components/footComp";
import { getArticles } from "../api/api";
import pageLoad from "../pageload/pageload";

export default {
  components: { footComp, newsList, pageLoad },
  data() {
    return {
      schNews: {}, //招生信息
      profession: {}, //专业介绍
      subject: {}, //历年真题
      encroll: {}, //录取
      imgNew: {}, //图片新闻
      tip: "",
      tipShow: false,
      loading: true, //加载页面
      url: this.global.url
    };
  },
  created() {
    this._getSchoolNews(); //招生信息
  },
  methods: {
    //招生信息
    _getSchoolNews() {
      let data1 = JSON.parse(sessionStorage.getItem("data1"));
      this.loading = true;
      if (data1 == null) {
        let module = {
          sch_id: 1,
          cate_id: 136,
          page: 1,
          pagesize: 7
        };
        getArticles(module)
          .then(res => {
            if (res.status && res.data && res.data.arts.length > 0) {
              sessionStorage.setItem("data1", JSON.stringify(res.data));
              this.schNews = res.data;
              this._encroll(); //招生计划
            } else {
              this.tipCtr("暂无数据");
              this.loading = false;
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.schNews = data1;
        this._encroll(); //招生计划
      }
    },
    //招生计划
    _encroll() {
      let data2 = JSON.parse(sessionStorage.getItem("data2"));
      if (data2 == null) {
        let module = {
          sch_id: 1,
          cate_id: 137,
          page: 1,
          pagesize: 7
        };
        getArticles(module)
          .then(res => {
            if (res.status && res.data && res.data.arts.length > 0) {
              sessionStorage.setItem("data2", JSON.stringify(res.data));
              this.encroll = res.data;
              this._subject(); //历年招生
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.encroll = data2;
        this._subject(); //历年招生
      }
    },
    //历年招生
    _subject() {
      let data3 = JSON.parse(sessionStorage.getItem("data3"));
      if (data3 == null) {
        let module = {
          sch_id: 1,
          cate_id: 138,
          page: 1,
          pagesize: 7
        };
        getArticles(module)
          .then(res => {
            if (res.status && res.data && res.data.arts.length > 0) {
              sessionStorage.setItem("data3", JSON.stringify(res.data));
              this.subject = res.data;
              this._profession(); //专业介绍
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.subject = data3;
        this._profession(); //招生计划
      }
    },
    //专业介绍
    _profession() {
      let data4 = JSON.parse(sessionStorage.getItem("data4"));
      if (data4 == null) {
        let module = {
          sch_id: 1,
          cate_id: 40,
          page: 1,
          pagesize: 6
        };
        getArticles(module)
          .then(res => {
            if (res.status && res.data && res.data.arts.length > 0) {
              sessionStorage.setItem("data4", JSON.stringify(res.data));
              this.profession = res.data;
              this.imgNews(); //新闻信息
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.profession = data4;
        this.imgNews(); //新闻图片
      }
    },

    //新闻图片
    imgNews() {
      let data5 = JSON.parse(sessionStorage.getItem("data5"));
      this.loading = false;
      if (data5 == null) {
        let module = {
          sch_id: 1,
          cate_id: 149,
          page: 1,
          pagesize: 3
        };
        getArticles(module)
          .then(res => {
            if (res.status && res.data && res.data.arts.length > 0) {
              sessionStorage.setItem("data5", JSON.stringify(res.data));
              this.imgNew = res.data;
            } else {
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.imgNew = data5;
      }
    },
    // 跳转判断
    jump(info) {
      if (
        sessionStorage.getItem("INFO") != null &&
        sessionStorage.getItem("INFO") != "null" &&
        this.global.Base64.decode(sessionStorage.getItem("INFO"))
      ) {
        this.$router.push(info);
      } else {
        this.tipCtr("请先登录");
        return false;
      }
    },
    //tip控制方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    }
  }
};
</script>

<style scoped>
.pMore {
  top: 20px;
  right: 0;
  color: #3a5ae1;
}
.profession li a {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue